import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ExitViewModule } from '../../shared/components/exit-view/exit-view.component.module';
import { SharedServicesModule } from '../../shared/services/shared.services.module';
import { SdcNavComponent } from './sdc-nav.component';

@NgModule({
  declarations: [SdcNavComponent],
  imports: [CommonModule, SharedServicesModule, MatButtonModule, ExitViewModule],
  exports: [SdcNavComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SdcNavModule {}
